module.exports = __webpack_public_path__ + "img/mgw-bg-mgw-magic.7cba85bd.png";